/* This file contains JS codes that are common to both desktop and mobile to avoid duplicate */

/**
 * Tracking overrides specific to the JJA sites: Hespéride, 5five, Atmosphera (WP-35789, Elevate tracking plan).
 * These replace core DataLayerTrigger methods for this site only: keep them in line with
 * _app/_src/js/datalayer/v3/DataLayerTrigger.js when the core versions change.
 */
if (typeof DataLayerTrigger !== 'undefined') {

    // Same as the core version, but email logins also report the customer ID passed by the login forms
    DataLayerTrigger.login = function (method, action = '', userId = '', userEmail = '') {
        try {
            var dataLayer = window.dataLayer || [];
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && typeof method == 'string') {

                var getTrackingCookie = function (name) {
                    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                    return match ? decodeURIComponent(match[2]) : null;
                };

                // Social logins carry the ID through a secure cookie, email logins pass it as an argument
                var socialUserId = getTrackingCookie('wshop_social_login_uid');
                var finalUserId = socialUserId || ((userId && userId !== 'null') ? userId : '');

                // Immediately delete the cookie so it never double-fires on page refreshes
                if (socialUserId) {
                    document.cookie = 'wshop_social_login_uid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure;';
                }

                // user_email is removed by the tracking client config (wshop-client-config.js)
                pushToWshopBus({
                    'event': 'login',
                    'user_id': finalUserId,
                    'user_email': userEmail,
                    'method': method,
                    'login_location': (action == 'identification.php') ? 'Checkout' : 'header'
                });
                DataLayerTrigger.pushSocialConnect(method);
            }

        } catch (e) {
            console.error(e);
        }
    };

    // Same as the core version, plus:
    // - the cart snapshot read by begin_checkout is kept in line with the AJAX cart updates
    // - a product missing from the snapshot no longer throws
    DataLayerTrigger.cart_product_action = function (impressions, actionField, prodId, action, value = 0) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            // The cart snapshot is only rendered on page load, so keep it in line with the AJAX cart updates
            if (typeof dl_v3_impressions !== 'undefined' && impressions === dl_v3_impressions) {
                DataLayerTrigger.syncCartImpressions(prodId, action, value);
            }

            var impressions = JSON.parse(impressions);
            var actionField = JSON.parse(actionField);

            var selectedItem = [];

            for (var impression in impressions) {
                if (impressions[impression]['wshop_product_id'] == prodId || impressions[impression]['wishlist_product_id'] == prodId) {
                    selectedItem.push(impressions[impression]);
                }
            }

            // Unknown product (not in the cart snapshot): nothing reliable to report
            if (selectedItem.length === 0) {
                return;
            }

            if (value != null && value != 0 && value != undefined) {
                selectedItem[0]['quantity'] = Math.abs(value);
            }

            try {
                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && selectedItem.length > 0) {
                    var payload = {
                        event: action,
                        cart_id: actionField['cart_id'],
                        ecommerce: {
                            currency: actionField['currency'],
                            value: parseFloat(selectedItem[0]['price'] - selectedItem[0]['discount']),
                            items: selectedItem
                        }
                    };

                    // Add event_location only if the action is add_to_cart
                    if (action === 'add_to_cart') {
                        payload.event_location = DataLayerTrigger.getCurrentPageType();
                    }

                    pushToWshopBus(payload);
                }

            } catch (e) {
                console.error(e);
            }
        }
    };

    /**
     * Applies a cart quantity change to dl_v3_impressions and dlv3_action_fields, which begin_checkout
     * reads when the customer leaves the cart page.
     *
     * @param {string|number} prodId
     * @param {string} action add_to_cart or remove_from_cart
     * @param {number} value Quantity added or removed; when empty, a removal drops the whole line
     */
    DataLayerTrigger.syncCartImpressions = function (prodId, action, value) {
        if (action !== 'add_to_cart' && action !== 'remove_from_cart') {
            return;
        }

        try {
            var cartItems = JSON.parse(dl_v3_impressions);
            var cartActionField = (typeof dlv3_action_fields !== 'undefined') ? JSON.parse(dlv3_action_fields) : null;
            var itemIndex = -1;

            for (var i = 0; i < cartItems.length; i++) {
                if (cartItems[i]['wshop_product_id'] == prodId) {
                    itemIndex = i;
                    break;
                }
            }

            // A product that was not in the cart on page load cannot be described from here
            if (itemIndex === -1) {
                return;
            }

            var item = cartItems[itemIndex];
            var currentQuantity = parseInt(item['quantity'], 10) || 0;
            var changedQuantity = Math.abs(parseInt(value, 10) || 0);

            if (action === 'remove_from_cart') {
                changedQuantity = changedQuantity > 0 ? Math.min(changedQuantity, currentQuantity) : currentQuantity;
                item['quantity'] = currentQuantity - changedQuantity;

                if (item['quantity'] <= 0) {
                    cartItems.splice(itemIndex, 1);

                    // The +/- buttons find their product by rank in productFieldObject, which is also only
                    // rendered on page load: drop the line so the ranks match the refreshed cart
                    if (typeof productFieldObject !== 'undefined' && Array.isArray(productFieldObject)) {
                        for (var j = 0; j < productFieldObject.length; j++) {
                            if (productFieldObject[j] && productFieldObject[j]['id'] == prodId) {
                                productFieldObject.splice(j, 1);
                                break;
                            }
                        }
                    }
                }
            } else {
                changedQuantity = changedQuantity > 0 ? changedQuantity : 1;
                item['quantity'] = currentQuantity + changedQuantity;
            }

            dl_v3_impressions = JSON.stringify(cartItems);

            if (cartActionField) {
                var amountChange = (parseFloat(item['price']) || 0) * changedQuantity;
                var cartValue = (parseFloat(cartActionField['value']) || 0) + (action === 'remove_from_cart' ? -amountChange : amountChange);

                cartActionField['value'] = Math.max(0, Math.round(cartValue * 100) / 100);
                dlv3_action_fields = JSON.stringify(cartActionField);
            }
        } catch (e) {
            console.error(e);
        }
    };
}
